module.exports = ".type {\n  max-width: 50%; }\n\n.type-title {\n  vertical-align: super; }\n\n.margin-top {\n  margin-top: 0.5em; }\n\n.margin-left {\n  margin-left: 0.5em; }\n\n.field-title {\n  margin-right: 0.5em; }\n\n.deleteButton {\n  right: 0px;\n  position: absolute;\n  margin-right: 20px; }\n\n.warning {\n  color: #FF0000; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/suppliers/suppliers.component.scss
// module id = 592
// module chunks = 1